<template>
  <b-row class="bg-morado-claro mx-0 py-2 mt-1 borde-amarillo">
    <!-- Botonera navegacion -->
    <b-col cols="12" lg="5" order="1" order-lg="0">
      <b-nav
        pills
        justified
        class="my-2 my-lg-1 justify-content-lg-start text-morado-claro "
      >
        <b-nav-item
          class="px-1"
          :active="tabSeleccionada === 'detalle'"
          @click="toggleTab('detalle')"
          link-classes="px-0 font-weight-bold"
          id="navegacion-detalle"
          data-testid="navegacion-detalle"
          v-b-tooltip.hover
          title="Ver listado detallado de establecimientos"
        >
          <FontAwesomeIcon icon="th" class="mr-1" />
          <span class="text-morado-claro">Detalle</span>
        </b-nav-item>
        <b-nav-item
          class="px-1"
          :active="tabSeleccionada === 'lista'"
          @click="toggleTab('lista')"
          link-classes="px-0 font-weight-bold"
          id="navegacion-lista"
          data-testid="navegacion-lista"
          v-b-tooltip.hover
          title="Ver listado simple de establecimientos"
          ><FontAwesomeIcon icon="list-ul" class="mr-1" />
          <span class="text-morado-claro">Lista</span>
        </b-nav-item>
        <b-nav-item
          class="px-1"
          :active="tabSeleccionada === 'mapa'"
          @click="toggleTab('mapa')"
          link-classes="px-0 font-weight-bold"
          id="navegacion-mapa"
          data-testid="navegacion-mapa"
          v-b-tooltip.hover
          title="Ver resultado de establecimientos en mapa"
          ><FontAwesomeIcon icon="map-marked-alt" class="mr-1" />
          <span class="text-morado-claro">Mapa</span>
        </b-nav-item>
      </b-nav>
    </b-col>
    <!-- Botonera orden -->
    <b-col
      cols="12"
      lg="auto"
      order="0"
      order-lg="1"
      class="ml-md-auto"
      v-show="mostrarOrden"
    >
      <b-dropdown
        no-caret
        right
        class="mt-1 w-100 px-1"
        toggle-class="btn-azul-outline w-100 py-2 px-3"
        variant="outline"
        id="dropdown-orden-establecimientos"
        data-testid="dropdown-orden-establecimientos"
      >
        <template slot="button-content">
          <FontAwesomeIcon class="mr-2" icon="sort"></FontAwesomeIcon>
          {{ traducirOrdenATexto(orden) }}
        </template>
        <b-dropdown-item
          v-for="orden in criteriosOrden"
          :key="orden.valor"
          @click="cambiarOrden(orden)"
        >
          {{ orden.texto }}
        </b-dropdown-item>
      </b-dropdown>
    </b-col>
  </b-row>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faTh,
  faListUl,
  faMapMarkedAlt,
  faSort
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faTh, faListUl, faMapMarkedAlt, faSort);
export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    orden: {
      type: Object,
      required: true
    },
    tabSeleccionada: {
      type: String,
      default: "detalle"
    }
  },
  data() {
    return {
      criteriosOrden: [
        {
          valor: "ALUMNOS_POR_CURSO_ASCENDENTE",
          texto: "Menos Alumnos por Curso"
        },
        {
          valor: "ALUMNOS_POR_CURSO_DESCENDENTE",
          texto: "Más Alumnos por Curso"
        },
        {
          valor: "MATRICULA_ASCENDENTE",
          texto: "Menos matriculados"
        },
        {
          valor: "MATRICULA_DESCENDENTE",
          texto: "Más matriculados"
        }
      ]
    };
  },
  computed: {
    mostrarOrden() {
      return this.tabSeleccionada !== "mapa";
    }
  },
  methods: {
    //emite evento para cambiar tipo de vista
    toggleTab: function(valor) {
      this.$gtag.event("modificar-vista", {
        event_category: "botonera",
        event_label: "vista-" + valor,
        value: ""
      });
      this.$emit("toggleVista", valor);
    },
    //emite evento para cambiar criterio de orden
    cambiarOrden: function(valor) {
      let newValor = valor.texto.toLowerCase();
      newValor = newValor.replace(" ", "-");
      this.$gtag.event("modificar-orden-resultados", {
        event_category: "orden-resultados",
        event_label: "nuevo-orden-" + newValor,
        value: ""
      });
      this.$emit("cambioCriterioOrden", valor);
    },
    //calcula texto de orden
    traducirOrdenATexto(valor) {
      return valor.texto;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/busqueda/BotoneraNavegacion.vue